import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const ActionButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 14,
  color: '#080808',
  padding: '2px 15px',
  height: '38px',
  fontWeight: '400',
  backgroundColor: '#F3F3F3',
  border: 'none',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: '#F3F3F3',
    color: '#080808',
    border: 'none',
  },
  '&[aria-expanded="true"]': {
    backgroundColor: '#FFF8FA',
    color: '#BF295C',
  },

  '& .MuiButton-endIcon>*:nth-of-type(1)': {
    fontSize: '16px',
  },
});